module.exports = __webpack_public_path__ + "static/media/awslogo.4be6efa3.png";